import type { LaborLog, LaborLogBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<LaborLog, LaborLogBase>({
  tableName: "labor_logs",
  searchColumns: ["user_name", "notes"],
});

export class LaborLogService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
